import axios from "axios"
import { ILoginInputs, IRegisterInputs } from "../types/types"
import { useAuth } from "./auth.hook"


export const useRegister = () => {
    const {login} = useAuth()
    const registrate = async (registerData: IRegisterInputs) => {
        await axios.post('https://api.escuelajs.co/api/v1/users/', registerData)
        .then((responce) => {
            const input: ILoginInputs = {email: responce.data.email, password: responce.data.password}
            login(input)
        })
    }

    return {registrate}
}